var map = {
	"./collection-controller.js": 387,
	"./fragment-controller.js": 9047,
	"./message-controller.js": 8156,
	"./product-controller.js": 500,
	"./productquery-controller.js": 7176,
	"./toggle-attribute-controller.js": 504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;